import options from './http-headers.component';

export default {
    selector: 'httpHeaders',
    options
};
